@if (!disclaimerDismissed) {
  <empty-state icon="warning" [text]="'AI agent use can have unintended consequences' | translate">
    <div class="d-inline-flex align-items-center mt-3">
      <button class="btn btn-primary" (click)="activate()" translate>I understand</button>
    </div>
  </empty-state>
} @else {
  <div class="d-flex gap-3">
    <h5>Claude Desktop</h5>
    <badge scheme="success" translate>LAN</badge>
  </div>
  <p translate>
    You can connect Claude Desktop and Claude Code directly to the ELEMENTS system through the
    ELEMENTS Client. Go to Settings &rarr; Agents in the app to automatically configure Claude.
  </p>

  <div class="d-flex gap-3 mt-5">
    <h5 translate>MCP over LAN</h5>
    <badge scheme="success" translate>LAN</badge>
  </div>
  <p>
    <span translate>
      ELEMENTS provides its own local MCP endpoint, which you can use with any local AI agent.
    </span>
  </p>

  <ul>
    <li>
      <strong class="me-2">MCP URL:</strong>
      <code class="selectable">{{ urlPrefix() }}/api/2/mcp</code>
    </li>
    <li>
      <strong class="me-2" translate>Authentication:</strong>
      <span translate>use a normal ELEMENTS API token as a Bearer token</span>
    </li>
  </ul>

  <div class="d-flex gap-3 mt-5">
    <h5 translate>Cloud MCP bridge</h5>
    <badge scheme="info"><span translate>Remote</span></badge>
  </div>
  <ul>
    <li>
      <strong class="me-2">MCP URL:</strong>
      <code class="selectable">https://mcp.elements.tv</code>
    </li>
    <li>
      <strong class="me-2" translate>Authentication:</strong>
      <span translate>
        OAUTH. You will be asked for a connection code, which will be shown below.
      </span>
    </li>
  </ul>
  @if (!parameters.values.mcpTunnelEnabled) {
    <message class="info">
      @if (identity.hasPermission("system:admin-access")) {
        <span translate>
          You need to enable the MCP bridge under System &rarr; General &rarr; AI first.
        </span>
      } @else {
        <span translate>The MCP bridge is disabled by the system admininistrator.</span>
      }
    </message>
  } @else {
    <div class="form-line">
      <div class="header">
        <div class="title" translate>Cloud MCP bridge connection code</div>
        <div class="description" translate>
          You'll need this code to connect remote AI agents to your ELEMENTS account
        </div>
      </div>
    </div>
    @if (mcpKey(); as mcpKey) {
      <div class="input-group mt-2" data-test-qa="mcpKey">
        <input class="form-control" type="text" readonly [value]="mcpKey.token" autoselect />
        <div class="input-group-append">
          <button
            class="btn btn-secondary"
            (click)="rotateMcpKey()"
            [ngbTooltip]="'Regenerate' | translate"
            data-test-qa="rotateMcpKey"
          >
            <i class="far fa-rotate"></i>
          </button>
        </div>
        <div class="input-group-append">
          <button
            class="btn btn-info"
            [ngbTooltip]="'Copy to clipboard' | translate"
            [copyToClipboardButton]="mcpKey.token"
          >
            <i class="far fa-fw fa-copy"></i>
          </button>
        </div>
      </div>
    }
    <div class="form-line mt-4">
      <div class="header">
        <div class="title" translate>Connected MCP bridge agents</div>
        <div class="description" translate>
          AI assistants you have previously authorized to access ELEMENTS on your behalf
        </div>
      </div>
    </div>
    <entity-list [entities]="mcpSessions()" className="list-group list-group-light">
      <div class="list-group-item d-flex align-items-center" *entityListItem="let session">
        <i class="far fa-robot me-2"></i>
        <div class="me-auto">
          <div>{{ session.clientLabel || ("Connected agent" | translate) }}</div>
          <div
            class="text-muted small"
            translate="Added on {date}"
            [translateParams]="{ date: (session.created | date: 'medium') }"
          ></div>
        </div>
        <button
          class="btn btn-link"
          (click)="revokeMcpSession(session)"
          [ngbTooltip]="'Revoke' | translate"
          data-test-qa="revokeMcpSession"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>
    </entity-list>
  }
}
